<div class="container report-container">

  <!-- Edits Submitted -->
  @if (isEditSubmission) {
    <div class="row" align="center">
      <h5 i18n class="blue-heading-title">
      Edits Submitted
    </h5>
    </div>
  }
  @if (isEditSubmission) {
    <div class="row" align="center">
      <p i18n>
      Your edits have been sent to Archipelago and been updated in your records.
    </p>
    </div>
  }

  <!-- Text that shows if the report was successfully sent to DFO -->

  @if (reportSent && !isEditSubmission) {
    <div>
      <div class="row"
        align="center">
        <h5 i18n class="blue-heading-title">
        Report Submitted
      </h5>
      </div>
      @if (reportName == 'Start Fishing Report') {
        <div class="row" align="center">
          <p i18n>
        Your start report to hail out has been sent to DFO
      </p>
        </div>
      }
      @if (reportName == 'End Fishing Report') {
        <div class="row" align="center">
          <p i18n>
        Your end report to hail in has been sent to DFO
      </p>
        </div>
      }
      <div class="row"
        align="center">
        <p i18n>
        It will take DFO 10-15 minutes to process the report and return a confirmation number. <br />
        You must be online to receive the confirmation number in the app.
      </p>
      </div>
    </div>
  }


  <!-- Text that shows if the report was unable to be sent to DFO -->

  @if (!reportSent && !isEditSubmission) {
    <div>
      <div class="row"
        align="center">
        <h5 i18n class="blue-heading-title">
        Unable To Submit Report
      </h5>
      </div>
      <div class="row"
        align="center">
        <p i18n>
        Your
        <i>
          {{reportName }}
        </i>
        has been saved but we were unable to submit it to DFO. Please check your internet
        connection then visit the
        <b>
          Records
        </b>
        page to resubmit your report.
      </p>
      </div>
    </div>
  }

  @if (reportName == 'End Fishing Report') {
    <div class="row" align="center">
      <p i18n>
      If you have to submit an offload catch report for this trip, do so before starting a new trip.<br />
      Once you start a new trip you will be unable to submit an offload catch report for this trip.
    </p>
    </div>
  }


  <!-- OK button -->

  <div class="row bottom-buttons">

    <div class="col-5"></div>

    <div class="col-2">
      <div class="row">
        <button mat-raised-button
          class="fishing-button-red"
          type="submit"
          (click)="sharedMethodsService.toHome(userDetails.currHomepage)">
          <span i18n>
            OK
          </span>
        </button>
      </div>

    </div>

    <div class="col-5"></div>

  </div>

</div>
